//custom js code here
 document.addEventListener("DOMContentLoaded", function () {
     let adaIconBox = document.querySelector(".ada-icon--box");

     if (adaIconBox) {
         adaIconBox.addEventListener("click", function () {
            let checkButton = setInterval(function () {
                 let accessiblyButton = document.getElementById("accessiblyAppDialogButton");
                 if (accessiblyButton) {
                     accessiblyButton.click();
                     clearInterval(checkButton); // Stop checking once button is found
                 }
             }, 500); // Check every 500ms
         });
     }
 });
